<template lang="pug">
  app-modal(
    titulo="Cadastrar Protesto",
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      validation-observer.analise(ref='validation' tag='div')
        validation-provider(rules="required", v-slot="{ errors }", name="motivo")
          app-label(label="Motivo:", :required="true")
          el-input(
            v-model="motivo",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
        div.mt-30px
          app-label(label="Justificativa:", :required="true")
          validation-provider(rules="required", v-slot="{ errors }", name="justificativa")
            app-editor-texto.input(
              @onTextChange="onTextChange",
              v-model="justificativa",
              :class="{'erro' : errors.length}"
              ref="editorTexto"
            )
            span.help.erro {{ errors[0] }}
          app-label(label="Anexos:", :required="true" style="margin-top: 15px")
          validation-provider(:rules="isAnexosValidos", v-slot="{ errors }", name="anexos")
            app-anexo(
              id="upload-anexo",
              @uploadFile="uploadFile",
              :files="anexos",
              :errors="errors",
              @removeFile="removeFile"
              @downloadDocumentoCadastro="downloadDocumentoCadastro",
              :tipoExibir="'ANEXO_ANALISE'"
              style="margin-top: 0"
            )
    template(slot="footer")
      el-row(
        type="flex",
        justify="space-between"
      )
        el-button(
          @click="$emit('closeModal')",
          size="small"
        )
          b Cancelar
        el-button(
          type="success",
          @click="save",
          size="small"
        )
          i.fa.fa-share-square &nbsp
          b &nbsp Cadastrar
</template>

<script>
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import AppModal from '@/components/AppModal'
import AppUtilizarButtons from '../AppUtilizarButtons'
import AppLabel from '@/components/AppLabel.vue'
import AppEditorTexto from '@/components/AppEditorTexto.vue'
import AppAnexo from '@/components/AppAnexo.vue'
import axios from '@/utils/api'
import FileSaver from 'file-saver'

export default {
  components: {
    AppModal,
    AppUtilizarButtons,
    AppLabel,
    AppEditorTexto,
    AppAnexo
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      motivo: '',
      justificativa: '',
      tiposArquivosPermitidosMapas: '.png, .jpg, .jpeg, .pdf, .doc, .docx',
      anexos: []
    }
  },

  computed: {
    isAnexosValidos () {
      return this.anexos.length === 0 ? 'required' : ''
    }
  },

  props: {
    idProcesso: {
      type: Number,
      required: true
    }
  },
  methods: {
    async save () {
      const isValid = await this.$refs.validation.validate()
      if (isValid) {
        const protesto = {
          motivo: this.motivo,
          justificativa: this.justificativa,
          documentos: this.anexos,
          idProcesso: this.idProcesso
        }

        axios({
          method: 'POST',
          url: `protesto/criar`,
          error: true,
          data: protesto
        }).then(() => {
          this.$emit('closeModal')
          this.showNotificacao(
            this.$messages.TIPO_SUCCESS,
            this.$messages.TITULO_SUCCESS,
            'Protesto cadastrado com sucesso.'
          )
          this.$emit('setHasProtesto', true)
        }).catch((e) => {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            this.$messages.ERROR_MESSAGE
          )
        })
      }
    },

    uploadFile (file) {
      this.anexos.push({
        key: file.response,
        nome: file.name,
        tipo: {
          id: 51,
          codigo: 'ANEXO_ANALISE'
        }
      })
    },
    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          this.deleteAnexo(documento)
        },
        () => {}
      )
    },

    deleteAnexo (documento) {
      if (documento.id) {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.id === documento.id)
        )
        this.anexos.splice(index, 1)
      } else {
        const index = this.anexos.indexOf(
          this.anexos.find(a => a.key === documento.key)
        )
        this.anexos.splice(index, 1)
      }
    },
    downloadDocumentoCadastro (documento) {
      this.getDownload(documento)
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    onTextChange (text) {
      this.justificativa = text
    }
  }
}
</script>

<style scoped lang="scss">
  .mt-30px {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalCadastrarProtesto.vue